import React, { useState, useEffect, useRef } from 'react'
import {useStoreState} from "pullstate";
import ModelList from '../components/ModelList';
import ModelForm from '../components/ModelForm';
import {UIStore} from "../components/stores/UIStore";
import ModelFilter from '../components/ModelFilter';
import MyModal from '../components/UI/modal/MyModal';
import MyLoader from '../components/UI/Loader/MyLoader';
import MyButton from '../components/UI/button/MyButton';
import {useModels} from '../hooks/useModels';
import ModelService from '../API/ModelService';
import {useFetching} from '../hooks/useFetching';
import {getPageCount} from '../utils/pages'
import MyPagination from '../components/UI/pagination/MyPagination';
import { useObserver } from '../hooks/useObserver';
import MySelect from '../components/UI/select/MySelect';
import ModelZone from '../components/ModelZone';

function Models() {
  
  const [models, setModels] = useState([])
  const [filter, setFilter] = useState({sort: '', query: ''})
  const [modalWindow, setModalWindow] = useState(false)
  const [modalShowZone, setModalShowZone] = useState(false)
  const [totalPages, setTotalPages] = useState(0)
  const [limit, setLimit] = useState(10)
  const [num3dModel, setNum3dModel] = useState(10)
  const [page, setPage] = useState(1)
  const sortedAndSearchedModels = useModels(models, filter.sort, filter.query)
  const lastElement = useRef()

  const [fetchModels, isModelsLoading, modelError] = useFetching(async (limit,page) => {
    const response = await ModelService.getAll(limit, page)
    setModels([...models, ...response.data])
    const totalCount = response.headers['x-total-count']
    setTotalPages(getPageCount(totalCount, limit))
  })

 useObserver(lastElement, page < totalPages, isModelsLoading, () => {
   setPage(page+1)
 })

  useEffect(() => {
    fetchModels(limit, page)
  }, [page, limit])
  
  const createModel = (newModel) => {
    setModels([...models, newModel])
    setModalWindow(false)
  }

  const removeModel = (model) => {
    setModels(models.filter(m => m.id !== model.id))
  }

  const changePage = (page) => {
    setPage(page)
  }

  const showZone3d = (num) => {
    setModalShowZone(true)
    setNum3dModel(num)
  }

  // const isDarkMode = UIStore.useState(s => s.isDarkMode);
  const {isDarkMode, user}  = useStoreState(UIStore, s => ({
    isDarkMode: s.theme.isDarkMode,
    user: s.user
  }))



  return (
    <div className={`App ${isDarkMode ? "dark" : "light"}`}>

      <MyModal visible={modalWindow} setVisible={setModalWindow} >
        <ModelForm create={createModel} />
      </MyModal>

      <MyModal visible={modalShowZone} setVisible={setModalShowZone} >
        <ModelZone num3dModel={num3dModel}/>
      </MyModal>

      {/* <div className='polekrana' style={{overflowX: 'scroll'}}> */}
      <div>

      <MyButton style={{marginTop: '30px'}} onClick={() => setModalWindow(true)}>
        Add new model
      </MyButton>

        {/* <div>user: {user}</div> */}
        <MyButton style={{margin: '10px'}}
          onClick={() =>
            UIStore.update(s => {
              s.theme.isDarkMode = !isDarkMode;
            })
          }>
          Change to {` ${!isDarkMode ? "Dark" : "Light"}`} mode
        </MyButton>
        {/* <Counter />
        <ClassCounter /> */}
        <hr style={{margin: '15px 0'}}/>

        <ModelFilter 
          filter={filter} 
          setFilter={setFilter}
        />

        <MySelect
         value={limit}
         onChange={value => setLimit(value)}
         defaultValue="Number of models in page"
         options={[
           {value: 5, name: '5'},
           {value: 10, name: '10'},
           {value: 25, name: '25'},
           {value: -1, name: 'Show all'}
         ]}
        />

        {modelError &&
          <h1>Error ${modelError}</h1>
        }

        <ModelList showZone3d={showZone3d} remove={removeModel} models={sortedAndSearchedModels} title="List of models" />
        <div ref={lastElement} style={{height: '20px', background: 'teal'}}/>

        {isModelsLoading &&
          <div style={{display: 'flex', justifyContent: 'center', marginTop: '50px'}}> <MyLoader /> </div>
        }

        {/* <MyPagination 
          page={page} 
          changePage={changePage} 
          totalPages={totalPages} 
        /> */}

     </div>
     {/* <div className='polekrana'>
        <ModelZone />
     </div> */}
    </div>
  )
}

export default Models
